/** Chart colors according to library standards  */
/** Reference: react-ui/src/scss/base/_css_variables.scss CHART COLOR LIBRARY */
export const CHART_COLORS = {
  chartLight6Blue: '#e4f3fa',
  chartLight5Blue: '#c7dfee',
  chartLight4Blue: '#a6cce5',
  chartLight3Blue: '#85badb',
  chartLight2Blue: '#63a7d1',
  chartLight1Blue: '#4194c7',
  chartStandardBlue: '#2081be',
  chartDark1Blue: '#1b6da1',
  chartDark2Blue: '#165984',
  chartDark3Blue: '#114667',
  chartDark4Blue: '#0c334b',
  chartDark5Blue: '#08202f',
  chartLight6Red: '#fde5e5',
  chartLight5Red: '#fac9c7',
  chartLight4Red: '#f7a8a6',
  chartLight3Red: '#f48885',
  chartLight2Red: '#f16863',
  chartLight1Red: '#ee4741',
  chartStandardRed: '#ec2720',
  chartDark1Red: '#c8211b',
  chartDark2Red: '#a41b16',
  chartDark3Red: '#811511',
  chartDark4Red: '#5e0f0c',
  chartDark5Red: '#3b0908',
  chartLight6Green: '#e0f8f3',
  chartLight5Green: '#c0f1e5',
  chartLight4Green: '#9be8d6',
  chartLight3Green: '#76e0c7',
  chartLight2Green: '#51d8b8',
  chartLight1Green: '#2bcfa8',
  chartStandardGreen: '#05c799',
  chartDark1Green: '#04a881',
  chartDark2Green: '#038a6a',
  chartDark3Green: '#026c53',
  chartDark4Green: '#014f3c',
  chartDark5Green: '#013126',
  chartLight6Yellow: '#fefae7',
  chartLight5Yellow: '#fcf6ca',
  chartLight4Yellow: '#faf1aa',
  chartLight3Yellow: '#f8eb8b',
  chartLight2Yellow: '#f7e66c',
  chartLight1Yellow: '#f5e14c',
  chartStandardYellow: '#f4dc2c',
  chartDark1Yellow: '#ceba25',
  chartDark2Yellow: '#a9981e',
  chartDark3Yellow: '#857818',
  chartDark4Yellow: '#615711',
  chartDark5Yellow: '#3d370b',
  chartLight6Purple: '#faeaff',
  chartLight5Purple: '#ecc5fd',
  chartLight4Purple: '#e0a3fd',
  chartLight3Purple: '#d581fc',
  chartLight2Purple: '#ca5ffb',
  chartLight1Purple: '#be3cfa',
  chartStandardPurple: '#b319fa',
  chartDark1Purple: '#9715d3',
  chartDark2Purple: '#7c11ad',
  chartDark3Purple: '#610d88',
  chartDark4Purple: '#470963',
  chartDark5Purple: '#2c063e',
  chartLight6Royal: '#e5e5f8',
  chartLight5Royal: '#cac6f3',
  chartLight4Royal: '#aba5eb',
  chartLight3Royal: '#8c83e4',
  chartLight2Royal: '#6d62dd',
  chartLight1Royal: '#4d40d6',
  chartStandardRoyal: '#2e1ecf',
  chartDark1Royal: '#2619af',
  chartDark2Royal: '#1f148f',
  chartDark3Royal: '#191071',
  chartDark4Royal: '#120b52',
  chartDark5Royal: '#0b0733',
  chartLight6Teal: '#e3ffff',
  chartLight5Teal: '#bff4f7',
  chartLight4Teal: '#99eef2',
  chartLight3Teal: '#73e8ed',
  chartLight2Teal: '#4de1e8',
  chartLight1Teal: '#26dbe3',
  chartStandardTeal: '#00d5df',
  chartDark1Teal: '#00b4bd',
  chartDark2Teal: '#00949b',
  chartDark3Teal: '#007479',
  chartDark4Teal: '#005458',
  chartDark5Teal: '#003537',
  chartLight6Pink: '#ffe3f2',
  chartLight5Pink: '#ffbfe5',
  chartLight4Pink: '#ff99d6',
  chartLight3Pink: '#ff73c7',
  chartLight2Pink: '#ff4db8',
  chartLight1Pink: '#ff26a8',
  chartStandardPink: '#f09',
  chartDark1Pink: '#d80081',
  chartDark2Pink: '#b1006a',
  chartDark3Pink: '#8b0053',
  chartDark4Pink: '#65003c',
  chartDark5Pink: '#3f0026',
  chartLight6Orange: '#fff1e7',
  chartLight5Orange: '#ffe2ca',
  chartLight4Orange: '#ffd1aa',
  chartLight3Orange: '#ffc08b',
  chartLight2Orange: '#ffaf6b',
  chartLight1Orange: '#ffa252',
  chartStandardOrange: '#ff8d2b',
  chartDark1Orange: '#d87724',
  chartDark2Orange: '#b1621d',
  chartDark3Orange: '#8b4d17',
  chartDark4Orange: '#653811',
  chartDark5Orange: '#3f230a',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const hexColors = Object.values(CHART_COLORS)

/**
 * To prevent using non-standard colors while working with hex colors, use this ChartColorsType.
 */
export type ChartColorsType = (typeof hexColors)[number]
